import { gql } from '@apollo/client';

export const CREATE_BLOG_POST_MUTATION = gql`
  mutation CreateBlogPost($data: BlogPostInput!) {
    createBlogPost(input: { data: $data }) {
      blogPost {
        id
      }
    }
  }
`;
